export default __webpack_public_path__ + "2da610e8318ed8ca3d37cbeb3f3afa96.gif";